import { useCallback, useEffect } from "react";
import config from "../utils/config";

const RECAPTCHA_SITE_KEY = config.RECAPTCHA_SITE_KEY;

// Load reCAPTCHA script
const loadRecaptchaScript = () => {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      resolve(window.grecaptcha);
      return;
    }

    const existingScript = document.querySelector(`script[src*="recaptcha"]`);
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.grecaptcha));
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

const useRecaptcha = () => {
  // Load script ngay khi component mount để badge xuất hiện sớm
  useEffect(() => {
    loadRecaptchaScript().catch((error) => {
      console.error("Failed to load reCAPTCHA:", error);
    });
  }, []);

  const executeRecaptcha = useCallback(async (action = "submit") => {
    try {
      const grecaptcha = await loadRecaptchaScript();

      return new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
          grecaptcha.execute(RECAPTCHA_SITE_KEY, { action }).then(resolve).catch(reject);
        });
      });
    } catch (error) {
      console.error("reCAPTCHA error:", error);
      throw error;
    }
  }, []);

  return { executeRecaptcha };
};

export default useRecaptcha;
